import { Button, Modal } from "antd";
import { useState } from "react";
import { DsaScreenDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import "./ConfirmationModal.scss";

export interface RebootScreenModalProps {
  isVisible: boolean;
  onClose: (fetch: boolean) => void;
  active: DsaScreenDto;
}

export function RebootScreenModal({
  isVisible,
  onClose,
  active
}: RebootScreenModalProps) {
  const [loading, setLoading] = useState(false);
  
  async function reboot() {
    if (!active.serial) return;
    setLoading(true);
    await DSAApi.sendDeviceCommand(active.serial, {command: 'reboot'});
    setLoading(false);
    onClose(true);
  }

  return (
    <Modal
      className={"confirmation-modal clean"}
      visible={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Rebooting your screen will temporarily stop all content from displaying.</h2>
      </header>

      <p>The process will take about 2 minutes to complete.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={() => reboot()}
          loading={loading}
        >
          Reboot
        </Button>
      </footer>
    </Modal>
  );
}
